import { Box, Button } from "@mui/material";
import { Link } from "react-router-dom";

const NavAccount = () => {

    return (
        <Box
            p={2}
            display="flex"
            flexDirection="column"
            gap={2}
        >
            <Button
                component={Link}
                to={'/account'}
            >Основное
            </Button>
            <Button
                component={Link}
                to={'/account/sell'}
            >Продать монеты
            </Button>
            <Button
                component={Link}
                to={'/account/transactions'}
            >Транзакции
            </Button>
        </Box>
    )

}

export default NavAccount;